module.exports = ":host{overflow-y:auto}.pageWrapper{padding:0}"